import Layout from 'antd/es/layout';
const { Footer } = Layout;

export default Footer;
